// extracted by mini-css-extract-plugin
export default {"root":"PricingTable_root__e9Kfn","divider":"PricingTable_divider__u+YHk","extra":"PricingTable_extra__GwNl7","hint":"PricingTable_hint__H8nSr","table":"PricingTable_table__jJW+6"};